import React, { Component } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import Octicon, {Person, Info} from '@github/octicons-react';
import UserIdentity from 'components/controls/userIdentity';
import Utils from "context/utils";

export default class RevisionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      author: null
    };
  }

  componentDidMount() {
    this.loadAuthor();
  }

  loadAuthor() {
    // Load author
    this.props.app.api.usersIdGet(this.props.revision.author_id)
      .then(response => {
        this.setState({
          author: response.data.user
        });
      }, error => {});
  }

  handleShowDetails = () => {
    this.props.shell.shellInterface.toggleDetails();
  }

  render() {
    var revision = this.props.revision;

    return (
      <>
        {/* Rendered directly into a Card.Header in several places (with no separate title before
            it) — wrapped in .card-header-meta so the global eyebrow header style (uppercase,
            letter-spaced, small — src/pages/Blob/index.css) doesn't apply to this summary line;
            it's metadata, not a title. */}
        <span className="card-header-meta">
          {this.state.author
            ? <UserIdentity user={this.state.author} fallback={this.props.revision.author_id} showIdentifier={false}/>
            : <><Octicon icon={Person}/>&nbsp;</>
          } | {revision.comment}
        </span>
        <span className="float-right">
          {Utils.formatTimeAgo(revision.created_at)} | <strong>{revision.phase}</strong>

          {this.props.shell && !this.props.shell.details.visible &&
            <>
              &nbsp;&nbsp;&nbsp;
              <ButtonGroup size="sm" className="header-options">
                <Button variant="light" onClick={this.handleShowDetails}><Octicon icon={Info}/></Button>
              </ButtonGroup>
            </>
          }
        </span>
      </>
    );
  }
}
